import ACTIONS from '../constants/actions';

export const initialState = {
  subscribeForm: {},
  subscribeSending: false,
  questionForm: {},
  questionSending: false,
  rubricRequestForm: {},
  rubricRequestSending: false,
};

const userRequestsReducer = function(state = initialState, action) {
  const actionHandlers = {
    [ACTIONS.CHANGE_SUBSCRIBE_FORM]() {
      return {
        ...state,
        subscribeForm: {...action.payload.changes}
      };
    },
    [ACTIONS.SEND_SUBSCRIBE_FORM]() {
      return {
        ...state,
        subscribeSending: true,
        subscribeForm: {process: true}
      };
    },
    [ACTIONS.SEND_SUBSCRIBE_FORM_SUCCESS]() {
      return {
        ...state,
        subscribeSending: false,
        subscribeForm: {done: true}
      };
    },
    [ACTIONS.SEND_SUBSCRIBE_FORM_FAILED]() {
      return {
        ...state,
        subscribeSending: false,
        subscribeForm: {errors: action.payload.errors}
      };
    },
    [ACTIONS.SEND_QUESTION_FORM]() {
      return {
        ...state,
        questionSending: true,
        questionForm: {process: true}
      };
    },
    [ACTIONS.CHANGE_QUESTION_FORM]() {
      return {
        ...state,
        questionForm: {...action.payload.changes}
      };
    },
    [ACTIONS.SEND_QUESTION_FORM_SUCCESS]() {
      return {
        ...state,
        questionSending: false,
        questionForm: {done: true}
      };
    },
    [ACTIONS.SEND_QUESTION_FORM_FAILED]() {
      return {
        ...state,
        questionSending: false,
        questionForm: {errors: action.payload.errors}
      };
    },
    [ACTIONS.SEND_RUBRIC_REQUEST_FORM]() {
      return {
        ...state,
        rubricRequestSending: true,
        rubricRequestForm: {process: true}
      };
    },
    [ACTIONS.CHANGE_RUBRIC_REQUEST_FORM]() {
      return {
        ...state,
        rubricRequestForm: {...action.payload.changes}
      };
    },
    [ACTIONS.SEND_RUBRIC_REQUEST_FORM_SUCCESS]() {
      return {
        ...state,
        rubricRequestSending: false,
        rubricRequestForm: {done: true}
      };
    },
    [ACTIONS.SEND_RUBRIC_REQUEST_FORM_FAILED]() {
      return {
        ...state,
        rubricRequestSending: false,
        rubricRequestForm: {errors: action.payload.errors}
      };
    },
  };

  if (action.type in actionHandlers) {
    return actionHandlers[action.type]();
  }

  return state;
};

export default userRequestsReducer;
